import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a2a49a0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"
import style0 from "./index.vue?vue&type=style&index=0&id=7a2a49a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a49a0",
  null
  
)

export default component.exports